<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="4">
              <b-form-group
                label="Order Name"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="order-name"
              >
                <b-form-input
                  id="order-name"
                  v-model="search_condition.orderName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Order No."
                label-cols-sm="4"
                label-align-sm="right"
                label-for="order-number"
              >
                <b-form-input
                  id="order-number"
                  trim
                  v-model="search_condition.orderNumber"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Device Model"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="model-name"
              >
                <b-form-input
                  id="model-name"
                  trim
                  v-model="search_condition.deviceModelName"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Production Time"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="create-time"
              >
                <date-picker
                  v-model="createTime"
                  format="MM/DD/YYYY"
                  range
                  append-to-body
                  lang="en"
                  placeholder="Select date"
                ></date-picker>
              </b-form-group>
            </b-col>

            <!-- 所属客户 -->
            <b-col lg="4">
              <b-form-group
                label="Affiliated Customer"
                label-cols-lg="4"
                label-align-lg="right"
                label-for="customer"
              >
                <b-form-select
                  id="customer"
                  v-model="search_condition.supplierId"
                  :options="types.allSupplier"
                  value-field="id"
                  text-field="brandName"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="order-status"
              >
                <b-form-select
                  id="order-status"
                  v-model="search_condition.status"
                  :options="types.statuss"
                ></b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'deviceProductionOrders::Create'"
            @click="gotoAdd"
            variant="primary"
            >Create</b-button
          >
          <div class="table-responsive mb-0">
            <b-table
              id="device-table"
              head-variant="light"
              show-empty
              empty-text="no records"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                  (search_condition.pageNum - 1) * search_condition.pageSize +
                  1
                }}
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'deviceProductionOrders::Details'"
                    size="sm"
                    variant="primary"
                    @click="show(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Details
                  </b-button>
                  <b-button
                    v-has="'deviceProductionOrders::Allocation'"
                    v-if="
                      row.item.isDistribution == 1 &&
                      row.item.status == 1 &&
                      row.item.isCancel == 1
                    "
                    size="sm"
                    variant="info"
                    @click="
                      assigningCustomer(row.item, row.index, $event.target)
                    "
                    class="mr-1"
                  >
                    Allocation
                  </b-button>
                  <b-button
                    v-has="'deviceProductionOrders::Cancel'"
                    v-if="row.item.status == 0 && row.item.isCancel == 1"
                    size="sm"
                    variant="danger"
                    @click="cancel(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Cancel
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    ref="page"
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>

        <!-- 分配客户弹窗 -->
        <b-modal
          ref="modal"
          v-model="assigningCustomerShow"
          title="Assigning Customer"
          @hidden="resetAssigningCustomerShow"
          hide-footer
        >
          <form
            ref="form"
            @submit="onSubmitAssigningCustomerShow"
            @reset="onResetAssigningCustomerShow"
          >
            <b-form-group
              label="Affiliated Customer:"
              label-cols-lg="4"
              label-align-lg="right"
              label-for="mode"
            >
              <multiselect
                v-model="supplier"
                :options="types.allSupplier"
                track-by="id"
                label="brandName"
                placeholder="Please select"
                @input="changeSupplierId(supplier)"
              >
              </multiselect>
            </b-form-group>
            <b-form-group
              label="Remarks:"
              label-cols-lg="4"
              label-align-lg="right"
              label-for="remark"
            >
              <b-form-textarea
                id="remark"
                v-model="typeform.distributionRemarks"
                placeholder="Enter Notes"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group label-cols-lg="2">
              <b-button type="submit" variant="primary">Confirm</b-button>
              <b-button type="reset" class="m-l-5 ml-1">Cancel</b-button>
            </b-form-group>
          </form>
        </b-modal>
      </b-col>
    </b-row>
    <!-- end main -->
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

/**
 * Cartridge Batch component
 */
export default {
  components: {
    DatePicker,
    Layout,
    PageHeader,
    Multiselect,
    timeZoneConversion,
  },
  data() {
    return {
      title: "Device Orders",
      items: [
        {
          text: "UNI-CORE",
          // href: "/"
        },
        {
          text: "Production Mgmt",
          // href: "/"
        },
        {
          text: "Device Orders",
          active: true,
        },
      ],
      tableData: [],
      totalRows: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "orderName", label: "Order Name", class: "text-center" },
        { key: "orderNumber", label: "Order No.", class: "text-center" },
        { key: "deviceModelName", label: "Device Model", class: "text-center" },
        {
          key: "status",
          label: "Status",
          formatter: (value) => {
            let a = "";
            this.types.statuss.filter((item) => {
              if (value === item.value) {
                a = item.text;
              }
            });
            return a;
          },
          class: "text-center",
        },
        {
          key: "batchQuantity",
          label: "Pre-production Quantity",
          class: "text-center",
        },
        {
          key: "actualQuantity",
          label: "Actual Quantity",
          class: "text-center",
        },
        {
          key: "supplierName",
          label: "Affiliated Customer",
          class: "text-center",
        },
        { key: "operationName", label: "Created By", class: "text-center" },
        {
          key: "productionTime",
          label: "Production Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTimes(value);
            } else {
              return "";
            }
          },
        },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        orderName: "",
        orderNumber: "",
        deviceModelName: "",
        startTime: "",
        endTime: "",
        status: "",
        supplierId: "",
      },
      createTime: ["", ""],
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          {
            text: "To be produced",
            value: 0,
            disabled: false,
          },
          {
            text: "Production of complete",
            value: 1,
            disabled: false,
          },
          {
            text: "Cancelled",
            value: 2,
            disabled: false,
          },
        ],
        allSupplier: [],
      },
      assigningCustomerShow: false,
      supplier: "",
      typeform: {
        id: "",
        supplierId: "",
        distributionRemarks: "",
      },
      isBusy: false,
      has_data: false,
    };
  },
  watch: {
    createTime: function (val) {
      this.search_condition.startTime = val[0]
        ? timeZoneConversion.queryTime(val[0])
        : val[0];
      if (val[1]) {
        this.search_condition.endTime = timeZoneConversion.queryTime(
          val[1].getTime() + 24 * 3600 * 1000 - 1
        );
      } else {
        this.search_condition.endTime = val[1];
      }
    },
  },
  computed: {
    /**
     * 计算rows
     */
    rows() {
      return this.totalRows;
    },
  },
  created() {
    this.init();
  },
  methods: {
    provider(ctx) {
      this.isBusy = true;
      return this.$api.Device.selectAllOrder(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.search_condition.pageNum = 1;
    },
    gotoAdd() {
      this.$router.push("deviceOrdersAdd");
    },
    show(item, index, button) {
      this.$router.push("deviceOrdersInfo?id=" + item.id);
    },
    assigningCustomer(item, index, button) {
      this.assigningCustomerShow = !this.assigningCustomerShow;
      this.typeform = {
        id: item.id,
        supplierId: "",
        distributionRemarks: "",
      };
      this.supplier = "";
    },
    changeSupplierId(value) {
      if (value) {
        this.typeform.supplierId = value.id;
      }
    },
    resetAssigningCustomerShow() {
      this.typeform = {
        id: "",
        supplierId: "",
        distributionRemarks: "",
      };
      this.supplier = "";
    },
    onResetAssigningCustomerShow(evt) {
      evt.preventDefault();
      this.typeform = {
        id: "",
        supplierId: "",
        distributionRemarks: "",
      };
      this.supplier = "";
      this.assigningCustomerShow = !this.assigningCustomerShow;
    },
    onSubmitAssigningCustomerShow(evt) {
      evt.preventDefault();
      this.$api.Device.deviceProductionDistribution(this.typeform).then(
        (res) => {
          if (res.success) {
            this.assigningCustomerShow = !this.assigningCustomerShow;
            this.$refs.table.refresh();
          }
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
        }
      );
    },
    cancel(a, b, c) {
      this.$api.Device.cancelDeviceProductionOrder({ id: a.id }).then((res) => {
        if (res.message) {
          this.$bvToast.toast(res.message);
        }
        if (res.success) {
          this.$refs.table.refresh();
        }
      });
    },
    init() {
      this.$api.Dropdown.selectAllSupplier().then((res) => {
        if (res.success && res.data) {
          this.types.allSupplier = this.types.allSupplier.concat(res.data);
        } else {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
        }
      });
    },
  },
};
</script>
